<template>
  <v-container>
    <v-row dense>
      <v-col cols="12">
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import { UserSession } from '@/store/configuracion'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'blue darken-2', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Cve Plantel', value: 'clave', class: 'black--text' },
          { text: 'Nombre Plantel', value: 'nombre', class: 'black--text' },
          { text: 'Empresa', value: 'empresa.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Activar / Desactivar', icon: 'mdi-circle-half-full', color: 'blue darken-2', action: 'toActiveDesactive', code: 'libre', hidden: '' },
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-2', action: 'updateData', code: 'libre', hidden: '' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-2', action: 'deleteData', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    usuario: {}
  }),
  components: {
    DataTableMain
  },
  mounted () {
    this.refreshData()
    this.usuario = UserSession()
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETListObjectsService', 'putServiceAction', 'deleteServiceAction', 'deleteObjetServiceAction']),
    ...mapMutations(['SHOW_MAIN_FORM_DIALOG', 'SHOW_MAIN_MESSAGE_DIALOG', 'CLEAR_DATA_LIST', 'SET_DATA_SECOUND_MAIN']),
    // ========== ========== ========== ========== ========== ========== \\
    // ========== ========== ========== ========== ========== ========== \\
    successAction (item) {
      this[item.action](item)
    },
    refreshData () {
      this.table.header.loading = true
      this.getUrl('GET/config/departamento/show')
    },
    newData (item) {
      this.SHOW_MAIN_FORM_DIALOG(
        {
          identity: 'create',
          with: 700,
          icon: 'mdi-plus-network',
          title: 'Nuevo Departamento',
          body: {
            objectMain: {},
            paramsDialog: {
              form: this.get_Departamento_Form,
              url: this.get_urls['POST/config/departamento/store'],
              message: 'Registro Agregado Correctamente',
              setmodel: true
            },
            paramsForm: {
              showCancel: true,
              showComfirm: true,
              nameCancel: 'Cancelar',
              nameComfirm: 'Guardar'
            }
          }
        }
      )
    },
    /* ========== ========== ========== ========== ========== ========== */
    tableAction (item) {
      this[item.action](item)
    },
    updateData ({ item }) {
      this.SHOW_MAIN_FORM_DIALOG(
        {
          identity: 'update',
          with: 700,
          icon: 'mdi-plus-network',
          title: 'Editar Departamento',
          body: {
            objectMain: item,
            paramsDialog: {
              form: this.get_Departamento_Form,
              url: this.get_urls['PUT/config/departamento/{id}'],
              message: 'Registro Agregado Correctamente',
              setmodel: true
            },
            paramsForm: {
              showCancel: true,
              showComfirm: true,
              nameCancel: 'Cancelar',
              nameComfirm: 'Guardar'
            }
          }
        }
      )
    },
    toActiveDesactive ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_MAIN_MESSAGE_DIALOG(
        {
          identity: 'ActiveDesactive',
          with: 700,
          image: 'warning',
          title: 'Advertencia',
          description: `Estas seguro de ${name} el registro ?`,
          subdescription: '',
          body: {
            showCancel: true,
            showComfirm: true,
            nameCancel: 'No, Cerrar',
            nameComfirm: `Sí, ${name}`,
            data: item
          }
        }
      )
    },
    deleteData ({ item }) {
      this.SHOW_MAIN_MESSAGE_DIALOG(
        {
          identity: 'ActiveDesactive',
          with: 700,
          image: 'warning',
          title: 'Advertencia',
          description: 'Estas seguro de eliminar el registro ?',
          subdescription: 'No podras revertir el movimiento',
          body: {
            showCancel: true,
            showComfirm: true,
            nameCancel: 'No, Cerrar',
            nameComfirm: 'Sí, Eliminar',
            data: item
          }
        }
      )
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.GETListObjectsService({ url: router })
      } else {
        this.getUrlServices()
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_ResponseDataDialog',
      'get_Departamento_Form'])
  },
  watch: {
    get_urls () { this.getUrl('GET/config/departamento/show') },
    get_ResponseDataDialog (data) {
      if (data.name === 'ActiveDesactive') {
        const url = this.get_urls['DELETE/config/departamento/activar-desactivar/{id}']
        this.deleteObjetServiceAction({ url: url, params: data.model.id, replace: '{id}' })
      }
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>

</style>
crear curd de roles
